// Import JS files from Mindstyle Core plugin
import "../../../../plugins/wpg-mindstyle-core/src/assets/js/components/stickybits";
import "../../../../plugins/wpg-mindstyle-core/src/assets/js/components/bootstrap";
import "../../../../plugins/wpg-mindstyle-core/src/assets/js/components/swiper";
import "../../../../plugins/wpg-mindstyle-core/src/assets/js/components/waypoints";

// files from theme
import "./main";
import "./components/blueconic-events";
import "./components/swiper-configurations";
import "./components/textarea-word-count";
import "./components/shop-category-menu";

// Plugins 
import "./plugins/woocommerce/add-to-cart-quantity";
import "./plugins/woocommerce/add-to-cart-variation";
import "./plugins/woocommerce/image-zoom";
import "./plugins/woocommerce/product-single";
import "./plugins/woocommerce/sticky-cart";
import "./plugins/woocommerce/sticky-add-to-cart";
import "./plugins/woocommerce/woocommerce";

// On loading the document execute a function:
document.addEventListener('DOMContentLoaded', () => {

});
